import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { BankAccount } from '../../firm.model';

@Component({
  selector: 'iriro-bank-account-dialog',
  templateUrl: './bank-account-dialog.component.html',
  styleUrls: ['./bank-account-dialog.component.scss'],
})
export class BankAccountDialogComponent {
  bankAccount: BankAccount = new BankAccount();
  bankAccountIsValid!: boolean;

  constructor(private readonly dynamicDialogRef: DynamicDialogRef) {}

  validateNewBankAccount() {
    if (this.bankAccount.account != null)
      if (this.bankAccount.bank != null) {
        this.bankAccountIsValid = true;
      }
  }

  saveNewAccount() {
    this.dynamicDialogRef.close(this.bankAccount);
  }

  clearNewAccount() {
    this.dynamicDialogRef.close();
  }
}
